import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import ReactPixel from 'react-facebook-pixel';

const environment = process.env.NODE_ENV;
const options = {
  autoConfig: true,
  debug: false
};
const pixelId = process.env.REACT_APP_PIXEL_ID as string;

if (environment.trim() === "production") {
  ReactPixel.init(pixelId, undefined, options);
  ReactPixel.pageView();
  console.log('Facebook Pixel Integrated');
}


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
